<template>
	<div class="transportista puiformheader">
		<v-layout wrap>
			<v-flex xs12 md6>
				<pui-field :label="this.$t('vtctransportistas.nombre')" :value="getNombre"></pui-field>
			</v-flex>
			<v-flex xs12 md6>
				<pui-field :label="this.$t('vtctransportistas.cif')" :value="getCif"></pui-field>
			</v-flex>
		</v-layout>
	</div>
</template>

<script>
// eslint-disable-next-line no-unused-vars
import PuiFormHeaderMixin from 'pui9-mixins/PuiFormHeaderMixin';

export default {
	name: 'transportistaformheader',
	mixins: [PuiFormHeaderMixin],
	data() {
		return {
			modelName: 'transportista'
		};
	},
	computed: {
		getNombre() {
			return this.model && this.model.nombre ? this.model.nombre : '';
		},
		getCif() {
			return this.model && this.model.cif ? this.model.cif : '';
		}
	},
	methods: {
		extendFilter(filter) {
			// Ya que es una tabla con varias vistas para que funcione correctamente se necesita indicar el modelo
			filter.model = 'transportista';
		}
	}
};
</script>
<style lang="postcss" scoped></style>
<i18n>
{
	"en": {
        "vtctransportistas.nombre": "Name",
        "vtctransportistas.cif": "Tax identifier"
    },
    "es": {
        "vtctransportistas.nombre": "Nombre",
        "vtctransportistas.cif": "Identificador fiscal"
    },
    "ca": {
        "vtctransportistas.nombre": "Nom",
        "vtctransportistas.cif": "Identificador fiscal"
    }
}
</i18n>
